import maplibregl from 'maplibre-gl';

/**
 * react-map-gl / @vis.gl/react-maplibre calls `map.getSky()` during the map `load` sequence.
 * Vietmap GL v6 has no `getSky` — add a no-op before any Map is constructed (import early from main.tsx).
 */
const { Map } = maplibregl;
if (Map?.prototype && typeof Map.prototype.getSky !== 'function') {
  Map.prototype.getSky = function vietmapGetSkyShim(): undefined {
    return undefined;
  };
}
